import { Controller } from "@hotwired/stimulus";
import { debounce } from "../plugins/debounce";

const DEBOUNCE_TIME = 300;

// Connects to data-controller="composition"
export default class extends Controller {
  static values = {
    margin: String,
  };

  static targets = [
    "boxItemPrice",
    "total",
    "diff",
    "filling",
    "template",
    "fields",
    "replacementTemplate",
    "replacementFields",
  ];
  static outlets = ["composition-row"];

  initialize() {
    this.debounceSubmit = debounce(
      () => this.element.requestSubmit(),
      DEBOUNCE_TIME,
    );
  }

  updateTotal(boxId) {
    const totalTarget = this.totalTargets.find(
      (target) => target.dataset.boxId === boxId,
    );

    const total = this.boxItemPriceTargets
      .filter((target) => target.dataset.boxId === boxId)
      .map((elem) => parseFloat(elem.value))
      .filter((elem) => !isNaN(elem))
      .reduce((a, b) => a + b, 0)
      .toFixed(2);

    totalTarget.value = total;

    this.updateDiff(boxId, total);
  }

  updateDiff(boxId, total) {
    const diffTarget = this.diffTargets.find(
      (target) => target.dataset.boxId === boxId,
    );

    const refPrice = parseFloat(diffTarget.dataset.boxPrice).toFixed(2);
    const diff = (total - refPrice).toFixed(2); // negative if current total less than refPrice

    diffTarget.value = diff < 0 ? diff : `+${diff}`;
    const diffClass = diff < 0 ? "negative" : "positive";

    diffTarget.classList.remove("negative", "positive");
    diffTarget.classList.add(diffClass);

    const diffAppend = diffTarget.parentElement.querySelector(
      ".input-group-append .input-group-text",
    );

    if (diffAppend) {
      diffAppend.classList.remove("negative", "positive");
      diffAppend.classList.add(diffClass);
    }
  }

  updateRowMargins(event) {
    this.margin = event.target.valueAsNumber;
    this.updateMarginEverywhere(this.margin);
  }

  updateMarginEverywhere(margin) {
    this.fillingTarget.value = 100 - margin;

    this.#getRowOutlets().forEach((outlet) => {
      outlet.updateMargin(margin);
      outlet.updateHelperPrice();
    });
  }

  prepend() {
    this.fieldsTarget.insertAdjacentHTML("beforebegin", this.#templateContent);
  }

  prependReplacement() {
    this.replacementFieldsTarget.insertAdjacentHTML(
      "beforebegin",
      this.#replacementTemplateContent,
    );
  }

  // private

  #getRowOutlets() {
    return this.compositionRowOutlets.filter(
      (outlet) =>
        outlet.element.closest("[data-controller~='composition']") ===
        this.element,
    );
  }

  get #templateContent() {
    return this.templateTarget.innerHTML
      .replace(/__INDEX__/g, Date.now())
      .replace(
        /__CHILDINDEX__/g,
        Math.max(
          ...this.#getRowOutlets()
            .filter((outlet) => outlet.element.dataset.replacement !== "true")
            .map((outlet) => parseInt(outlet.element.dataset.childIndex)),
        ) + 1,
      );
  }

  get #replacementTemplateContent() {
    return this.replacementTemplateTarget.innerHTML
      .replace(/__INDEX__/g, Date.now())
      .replace(
        /__CHILDINDEX__/g,
        Math.max(
          ...this.#getRowOutlets()
            .filter((outlet) => outlet.element.dataset.replacement === "true")
            .map((outlet) => parseInt(outlet.element.dataset.childIndex)),
        ) + 1,
      );
  }
}
